import {ELicensePeriod} from 'src/containers/Licenses/definitions';

import {ESmsOutMessageCategory, ESmsStatisticsChart, EWAConversation} from '../definitions';

export default {
  period: 'Период',
  downloadReport: 'Выгрузить отчет',
  hint: 'Количество единиц, за которые вам необходимо будет заплатить согласно вашему тарифу',
  more: 'Подробнее',
  direction: 'Направление',
  count: 'Количество',
  cost: 'Стоимость, {{currencySymbol}}',
  costPerSegment: 'Стоимость за 1 сегмент, {{currencySymbol}} ',
  operator: 'Оператор',
  type: 'Тип',
  outgoing: 'Исходящие',
  incoming: 'Входящие',
  incomingMessages: 'Входящие сообщения',
  outgoingMessages: 'Исходящие сообщения',
  messagesCount: 'Всего',
  sent: 'Отправлено',
  delivered: 'Доставлено',
  notDelivered: 'Не доставлено',
  read: 'Прочитано',
  total: 'Итого, {{currencySymbol}}',
  incomingCount: 'Количество входящих сообщений',
  outgoingCount: 'Количество исходящих сообщений',
  charged: 'Протарифицировано',
  promotional: 'Рекламные',
  service: 'Сервисные',
  other: 'Прочее',
  viberReport: {
    minimumPayment: 'Минимальный платеж',
    viberMinimumPayment: 'Минимальный платеж Viber, {{currencySymbol}}',
  },
  smsReport: {
    averageCostOld: 'Стоимость за 1 сообщение',
    outgoingHintOld: 'Стоимость сообщений зависит от количества сегментов в сообщении',
    ndsHint: 'Все цены указаны с НДС',
    emptyMessages: 'За выбранный период данных о сообщениях нет',
    subscriptionFee: 'Абонентская плата',
    operator: 'Оператор',
    priceForMonth: 'Стоимость, в месяц',
    trafficType: 'Тип трафика',
    segmentCount: 'Всего сегментов',
    multinaming: 'Мультинейминг',
    category: 'Категория',
    averageCost: 'Стоимость за 1 сообщение',
    totalCost: 'Стоимость итого, руб.',
    currency: 'Валюта',
    charged: 'Протарифицировано',
    billingInfo:
      'Указанная информация актуальна на момент выполнения итогового отчета. Данные за текущий месяц могут измениться',
    defaultInfo:
      'Указана предварительная информация, актуальная на момент выполнения итогового отчета. Точная информация будет доступна в конце отчетного периода',
    outgoingHint: 'Стоимость сообщений зависит от количества сегментов в сообщении (PDU)',
    categories: {
      [ESmsOutMessageCategory.SERVICE]: 'Сервис',
      [ESmsOutMessageCategory.AUTHORIZATION]: 'Авторизация',
      [ESmsOutMessageCategory.AUTH]: 'Авторизация',
      [ESmsOutMessageCategory.TEMPLATE_ADV]: 'Шаблонируемая реклама',
      [ESmsOutMessageCategory.ADVERTISEMENT]: 'Реклама',
      [ESmsOutMessageCategory.INFO]: 'Реклама',
      [ESmsOutMessageCategory.MARKETING]: 'Реклама',
      [ESmsOutMessageCategory.ADV]: 'Реклама',
    },
    download: 'Выгрузить отчет',
    averageCostHintOld:
      'Если для оператора действует степ-тарификация, то мы выводим усредненную стоимость сообщения для категории ',
    averageCostHint:
      'Длина одного сообщения до 160 символов в латинице или до 70 в кириллице. Если текст длиннее, он делится на несколько сообщений (до 150 латиницей / 66 кириллицей) и тарифицируется как соответствующее количество SMS.',
    detailReport: 'Детализация по сообщениям',
    detailReportButton: 'Сформировать отчет.xlsx',
    templates: 'Платные шаблоны',
    templateType: 'Тип шаблона',
    templateCount: 'Количество шаблонов',
    templateAverageCost: 'Стоимость, за единицу, в месяц',
    templateTotalCost: 'Сумма, в месяц',
    statisticsTotalCost: 'Всего потрачено за месяц: {{amount}} {{currency}}',
    statisticsChart: {
      [ESmsStatisticsChart.LICENSE]: 'Лицензия за все каналы: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.TEMPLATES]: 'Платные шаблоны: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.SUBSCRIPTION_FEE]: 'Абонентская плата: {{amount}} ({{percent}}%)',
      [ESmsStatisticsChart.OUT_MESSAGES]: 'Исходящие сообщения: {{amount}} ({{percent}}%)',
    },
  },
  whatsappReport: {
    ndsHint: 'Все цены указаны с НДС',
    for: 'за',
    licenseTableTitle: 'Лицензия',
    licensePeriodTitle: 'Период лицензии',
    licenseDuration: 'Срок действия лицензии',
    licenseBilled: 'Фактически начислено за период, {{currencySymbol}}',
    licensePeriod: {
      [ELicensePeriod.MONTH]: 'Ежемесячная',
      [ELicensePeriod.YEAR]: 'Годовая',
    },
    mauTableTitle: 'MAU / AMAU',
    mauInPackage: 'MAU в пакете',
    mauQuantity: 'Текущее кол-во MAU',
    remainingMau: 'Остаток MAU',
    amauQuantity: 'Текущее кол-во AMAU',
    amauPrice: 'Цена за AMAU, {{currencySymbol}} ',
    totalForAmau: 'Итого за AMAU, {{currencySymbol}} ',
    billing: 'Тарификация сообщений',
    billingHint:
      'Отображаются только ненулевые значения. Если какая-то категория сообщений отсутствует, то за выбранный период времени количество сообщений этой категории было нулевым.',
    free: 'Бесплатные',
    incomingMessages: 'Входящие коммуникации',
    incomingDialogs: 'Входящие диалоги',
    chatMessages: 'Нешаблонные',
    hsm: 'Шаблонные',
    user: 'Входящие',
    business: 'Исходящие',
    incomingConversation: {
      [EWAConversation.REFERRAL]: 'Бесплатные точки входа',
      [EWAConversation.SERVICE]: 'Входящие диалоги',
    },
    billedConversation: {
      [EWAConversation.SERVICE]: 'Нешаблонные',
      [EWAConversation.UTILITY]: 'Служебные',
      [EWAConversation.AUTHENTICATION]: 'Авторизационные',
      [EWAConversation.MARKETING]: 'Маркетинговые Cloud API',
      [EWAConversation.MARKETING_LITE]: 'Маркетинговые MM API',
    },
  },
  simpleReport: {
    ndsHint: 'Все цены указаны без НДС',
    licenseTableTitle: 'Лицензия',
    licensePeriodTitle: 'Период лицензии',
    licenseDuration: 'Срок действия лицензии',
    licenseBilled: 'Фактически начислено за период, {{currencySymbol}}',
    licensePeriod: 'Ежемесячная',
  },
};
